import { Component } from "@angular/core";

@Component({
    selector: 'app-inicio',
    templateUrl: './inicio.component.html',
    styleUrls: ['./inicio.component.scss']
})

export class InicioComponent {
    
}


// WEBPACK FOOTER //
// ./src/app/inicio/inicio.component.ts